// extracted by mini-css-extract-plugin
module.exports = {"legalAgreementText":"styles_legalAgreementText__GbrvE"};